<template>
  <div>
    <h1>{{ $t('login.resetPassword') }}</h1>
    <p>{{ $t('login.enterNewPassword') }}</p>
    <v-text-field v-model="newPassword" type="password" :label="$t('login.password')"></v-text-field>
    <v-text-field v-model="confirmNewPassword" type="password" :label="$t('login.password')"></v-text-field>
    <button class="button--secondary" :class="{ 'is-loading' : loading }" @click="submitReset" :disabled="loading || !enableSubmit"><i></i>{{ $t('login.resetPassword') }}</button>
  </div>
</template>

<script>
import rpcService from '@/core/services/rpc-service'
import toasts from '@/core/toasts'

export default {
  props: ['token'],
  data: () => ({
    newPassword: '',
    confirmNewPassword: '',
    loading: false
  }),
  methods: {
    submitReset() {
      if(this.newPassword && !this.loading) {
        this.loading = true
        rpcService.submitResetPassword(this.token, this.newPassword).done(() => {
          this.$router.replace({ query: null })
          toasts.success(this.$t('login.passwordResetSuccess'))
        }).fail(() => {
          toasts.error(this.$t('login.passwordResetError'))
        }).always(() => {
          this.loading = false
        })
      }
    }
  },
  computed: {
    enableSubmit() {
      return this.confirmNewPassword.length > 4 && this.confirmNewPassword === this.newPassword
    }
  }
}
</script>
